module.exports = __webpack_public_path__ + "static/media/activation_img.61f6ded3.svg";